import Image from "next/image";

import { useCheckIsMobile } from "@sellernote/shared/src/utils/hook";
import useOnceActivatedIntersectionObserver from "@sellernote/features/src/common/hooks/useOnceActivatedIntersectionObserver";
import CommonStyled from "@sellernote/shipda-kr/src/components/landing/index.styles";
import { SubSectionData } from "@sellernote/shipda-kr/src/components/landing/LandingSubSection/types";
import Chip from "@sellernote/ui/src/sds-v2/components/Chip";

import Styled from "./index.styles";

export default function LandingSectionCEO({
  chipLabel,
  title,
  titleMobile,
  desc,
  descMobile,
  imageInfo,
  mobileImageInfo,
}: SubSectionData) {
  const { isMobile } = useCheckIsMobile();

  const { target, isActivatedTarget } = useOnceActivatedIntersectionObserver({
    threshold: 0.3,
  });

  return (
    <Styled.containerWrapper ref={target}>
      <Styled.container>
        <Styled.contentsContainer>
          <Chip
            chipType="outline"
            label={chipLabel}
            className={`fade-up-animation ${isActivatedTarget ? "active" : ""}`}
          />

          <CommonStyled.sectionTitle
            className={`fade-up-animation ${isActivatedTarget ? "active" : ""}`}
          >
            {isMobile ? titleMobile || title : title}
          </CommonStyled.sectionTitle>

          <CommonStyled.sectionDesc
            className={`fade-up-animation ${isActivatedTarget ? "active" : ""}`}
          >
            {isMobile ? descMobile || desc : desc}
          </CommonStyled.sectionDesc>
        </Styled.contentsContainer>

        <Styled.imageWrapper
          className={`${
            isMobile ? `fade-up-animation` : `fade-in-and-spring-animation`
          } ${isActivatedTarget ? "active" : ""}`}
        >
          <Image
            src={isMobile ? mobileImageInfo.url : imageInfo.url}
            alt={`section-image`}
            width={isMobile ? mobileImageInfo.width : imageInfo.width}
            height={isMobile ? mobileImageInfo.height : imageInfo.height}
            placeholder="blur"
            blurDataURL="/assets/images/landing/section-image-blur-data.png"
          />
        </Styled.imageWrapper>
      </Styled.container>
    </Styled.containerWrapper>
  );
}
